export const CAMPAIGNS = 'CAMPAIGNS';
export const CAMPAIGN = 'CAMPAIGN';
export const TEMPLATE = 'TEMPLATE';
export const TEMPLATES = 'TEMPLATES';
export const REPORTS = 'REPORTS';
export const SUMMARY = 'SUMMARY';
export const BATCHES = 'BATCHES';
export const EVENTS = 'EVENTS';
export const SETTINGS = 'SETTINGS';
export const ATTACHMENT_TEMPLATE = 'ATTACHMENT_TEMPLATE';
export const ATTACHMENT_TEMPLATES = 'ATTACHMENT_TEMPLATES';
export const SURVEY_TEMPLATE = 'SURVEY_TEMPLATE';
export const SURVEY_TEMPLATES = 'SURVEY_TEMPLATES';
export const RECIPIENTQUERY = 'RECIPIENTQUERY';
export const RECIPIENTQUERIES = 'RECIPIENTQUERIES';
export const CONDITIONQUERIES = 'CONDITIONQUERIES';
export const SURVEYS = 'SURVEYS';
export const SCHEMA = 'SCHEMA';
export const ENRICHED_SCHEMA = 'ENRICHED_SCHEMA';
export const LISTS = 'LISTS';
export const GUEST_INSIGHTS = 'GUEST_INSIGHTS';

export const domainMetaData = {
  [CAMPAIGNS]: {
    resource: 'campaigns'
  },
  [CAMPAIGN]: {
    resource: 'campaign'
  },
  [TEMPLATE]: {
    resource: 'template'
  },
  [TEMPLATES]: {
    resource: 'templates'
  },
  [ATTACHMENT_TEMPLATE]: {
    resource: 'attachmentTemplate'
  },
  [ATTACHMENT_TEMPLATES]: {
    resource: 'attachmentTemplates'
  },
  [SURVEY_TEMPLATE]: {
    resource: 'surveyTemplate'
  },
  [SURVEY_TEMPLATES]: {
    resource: 'surveyTemplates'
  },
  [RECIPIENTQUERY]: {
    resource: 'recipient-queries'
  },
  [RECIPIENTQUERIES]: {
    resource: 'recipient-queries'
  },
  [CONDITIONQUERIES]: {
    resource: 'condition-queries'
  },
  [REPORTS]: {
    resource: 'reports'
  },
  [SUMMARY]: {
    resource: 'summary'
  },
  [BATCHES]: {
    resource: 'batches'
  },
  [EVENTS]: {
    resource: 'events'
  },
  [SURVEYS]: {
    resource: 'surveys'
  },
  [SETTINGS]: {
    resource: 'settings'
  },
  [SCHEMA]: {
    resource: 'schema'
  },
  [ENRICHED_SCHEMA]: {
    resource: 'enriched-schema'
  },
  [LISTS]: {
    resource: 'lists'
  },
  [GUEST_INSIGHTS]: {
    resource: 'guest-insights'
  }
};
